import React from 'react'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import store from './redux/stores/store'
import { Provider } from 'react-redux'
import './app.styles.scss'
import DashboardPage from './pages/dashboard/dashboard.page'
import RequireLogin from './components/require-login/require-login.component'
import AuthController from './pages/auth/auth.controller'
import DefaultTemplate from './templates/default/default.template'
import AuthTemplate from './templates/auth/auth.template'
import SecurityController from './pages/security/security.controller'
import ContentController from './pages/content/content.controller'

const AppController = () => {
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route path="/auth" component={() => <AuthTemplate><AuthController/></AuthTemplate>} />
          <Route path="/security" component={() => <RequireLogin><DefaultTemplate><SecurityController/></DefaultTemplate></RequireLogin>} />
          <Route path="/content" component={() => <RequireLogin><DefaultTemplate><ContentController/></DefaultTemplate></RequireLogin>} />
          <Route path="/" component={() => <RequireLogin><DefaultTemplate><DashboardPage/></DefaultTemplate></RequireLogin>} />
        </Switch>
      </Router>
    </Provider>
  )
}

export default AppController
